<template>
  <div class="item b-img">
    <div class="title">
      <b>낮은 신용평점도 가능</b>
    </div>
    <div class="content">
      자영업자 전문 심사로<br />
      자영업자에 가장 유리한 심사!
    </div>
    <div class="content2">
      <table>
        <tr>
          <th></th>
          <th>펀다나우</th>
          <th>타 금융기관</th>
        </tr>
        <tr>
          <td>신용<br />평점</td>
          <td>신용평점 390점 이상</td>
          <td>신용평점 830점 이상</td>
        </tr>
        <tr>
          <td>신용<br />평균</td>
          <td>현재 발생 중인 매출 기준</td>
          <td>작년 소득 서류 평가</td>
        </tr>
        <tr>
          <td>평균<br />승인률</td>
          <td>70% 이상</td>
          <td>10% 이하</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Three',
}
</script>

<style lang="scss" scoped>
.item {
  width: 280px;
  height: 340px;
  border-radius: 6px;
  box-shadow: 8px 10px 20px 0 rgba(0, 0, 0, 0.12);
  padding-top: 23px;
  background-color: #ffffff;
  overflow: hidden;

  .title {
    font-weight: 500;
    font-size: 20px;
    line-height: 1.35;
    letter-spacing: -0.63px;
    text-align: center;
    color: #333333;
    b {
      font-weight: 800;
      color: #333333;
    }
  }

  .content {
    font-weight: 500;
    font-size: 15px;
    line-height: 1.4;
    letter-spacing: -0.47px;
    text-align: center;
    color: #727d8c;
    margin-top: 9px;
  }

  .content2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    table {
      width: calc(241% / 280 * 100);
      font-size: 14px;
      line-height: 1.43;
      color: #333333;
      text-align: center;
      margin-top: 20px;
      border-collapse: collapse;

      th {
        font-weight: 800;
        font-size: 14px;
      }
      tr {
        border-top: 1px solid #d7e1ea;
        th:nth-child(1),
        tr:nth-child(1) {
          width: calc(58% / 241 * 100);
        }
        th:nth-child(2),
        td:nth-child(2) {
          background-color: #f6fbff;
          width: calc(74% / 241 * 100);
        }
        th:nth-child(3),
        tr:nth-child(3) {
          width: calc(109% / 241 * 100);
        }
        &:first-child {
          height: 35px;
          border-top: 1px solid #333333;
        }
        &:nth-child(2) {
          height: 52px;
          border-top: 1px solid #d7e1ea;
        }
        &:nth-child(3) {
          height: 72px;
          border-top: 1px solid #d7e1ea;
        }
        &:last-child {
          height: 52px;
          border-bottom: 2px solid #bac1c8;
        }
      }
    }
  }
}
</style>
